export default __webpack_public_path__ + "static/media/do.957628e8.svg";